import { Box, Dialog } from '@pocketlaw/tetris';
import { FuzzyModifier } from './FuzzyModifier';
import { InitialState } from './InitialState';
import { NoResults } from './NoResults';
import { SearchFieldModifier } from './SearchFieldModifier';
import { SearchInput } from './SearchInput';
import { SearchResult } from './SearchResult';
import { LoadingSkeleton } from './SearchResult/LoadingSkeleton';
import { SearchTypeModifier } from './SearchTypeModifier';
import { useUniversalSearch } from './useUniversalSearch';
import { StyledDialogHeader, Wrapper } from './styled';
export function SearchPopup() {
    const { searchText, data, loading, open, closeSearchPopup, modifiers, setModifiers } = useUniversalSearch();
    const isSearching = Boolean(searchText.length);
    const hasResult = isSearching && Boolean(data.totalHitsCount);
    if (!open) {
        return null;
    }
    return (<Dialog size="lg" onClose={closeSearchPopup}>
      <StyledDialogHeader>
        <SearchInput />
        <Box px="xl" pt="md" gap="md">
          <SearchTypeModifier modifiers={modifiers} setModifiers={setModifiers}/>
          <FuzzyModifier modifiers={modifiers} setModifiers={setModifiers}/>
          <SearchFieldModifier modifiers={modifiers} setModifiers={setModifiers}/>
        </Box>
      </StyledDialogHeader>

      <Wrapper>
        <Box p="md" flexDirection="column">
          {!isSearching && <InitialState />}

          {isSearching && loading && <LoadingSkeleton count={10}/>}

          {isSearching && !loading && !hasResult && <NoResults />}

          {isSearching && !loading && hasResult && <SearchResult />}
        </Box>
      </Wrapper>
    </Dialog>);
}
